import { Stack } from '@mui/material';
import FromAndToDatePicker from '../../../../../components/mui/FromAndToDatePicker';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getExpenseTypes } from '../../../../../redux/features/croSlice';
import GlobalSelectFieldWithoutFormikNew from '../../../../../components/mui/GlobalSelectFieldWithoutFormikNew';

export default function ExpenseFilter({ fromDate, setFromDate, toDate, setToDate, CRO, expType, setExpType }) {
  // normal variables
  const dispatch = useDispatch();

  // redux states

  const expenseType = useSelector((state) => state.cro.expenseTypes);
  const expenseTypeLoading = useSelector((state) => state.cro.loading);

  /*********************************************************************/

  // mounting only effect

  useEffect(() => {
    if (CRO) dispatch(getExpenseTypes());
  }, [dispatch, CRO]);

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} gap={1}>
      <FromAndToDatePicker fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate} />
      {CRO && (
        <GlobalSelectFieldWithoutFormikNew
          data={expenseType}
          disabled={expenseTypeLoading}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
          label={'Expense Type'}
          selectedDetails={expType}
          setChange={setExpType}
          sx={{
            width: { xs: '100%', sm: 250 },
          }}
        />
      )}
    </Stack>
  );
}
